import React from 'react';
import { Icon } from './Icon.js';
export const IconEnvelopePen = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M2 5V7L12 12L22 7V5", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M17 22L22.5 16.5L19.5 13.5L14 19V22H17Z", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M23 12.7568L21 10.7549V5H3V19H11V21H1V3H23V12.7568Z", fill: "currentColor", "data-color": "color-2", "data-stroke": "none" })));
};
//# sourceMappingURL=IconEnvelopePen.js.map